import { render, staticRenderFns } from "./Artist.vue?vue&type=template&id=51dad72a&scoped=true"
import script from "./Artist.vue?vue&type=script&lang=js"
export * from "./Artist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dad72a",
  null
  
)

export default component.exports